export enum ServiceCodesEnum {
  CHL_F_CHLAMYDIA_TREATMENT = "CHL-F",
  PRE_F_HIV_PREP = "PRE-F",
  CYS_F_CYSTITIS_TREATMENT = "CYS-F",
  VAG_F_VAGINAL_DRYNESS_TREATMENT = "VAG-F",
  FAC_F_FACIAL_HAIR_REMOVAL_TREATMENT = "FAC-F",
  T_THY_THYROID_HORMONE_HOME_TEST_KIT = "T-THY",
  T_TYP_DIABETES_HBA1C_HOME_TEST_KIT = "T-TYP",
  T_CGT_X_CHLAMYDIA_GONORRHOEA_TRICH_TEST_KIT_WOMEN = "T-CGT-X",
  T_TOT_X_STI_TEST_HOME_SWAB_KIT_WOMEN = "T-TOT-X",
  T_MSMCG_Y_CHLAMYDIA_GONORRHOEA_HOME_TEST_KIT_MSM = "T-MSMCG-Y",
  T_CHL_Y_CHLAMYDIA_HOME_TEST_KIT_MEN = "T-CHL-Y",
  T_CHL_X_CHLAMYDIA_HOME_TEST_KIT_WOMEN = "T-CHL-X",
  T_CG_X_CHLAMYDIA_GONORRHOEA_HOME_TEST_KIT_WOMEN = "T-CG-X",
  HAI_F_HAIR_LOSS_TREATMENT = "HAI-F",
  HAI_R_HAIR_LOSS_RETURN_TREATMENT = "HAI-R",
  ECZ_F_ECZEMA_TREATMENT = "ECZ-F",
  WEI_F_WEIGHT_LOSS_TREATMENT = "WEI-F",
  WEI_R_WEIGHT_LOSS_RETURN = "WEI-R",
  PEJ_F_PREMATURE_EJACULATION_TREATMENT = "PEJ-F",
  ERE_F_ERECTILE_DYSFUNCTION_TREATMENT = "ERE-F",
  ERE_R_ERECTILE_DYSFUNCTION_RETURN_TREATMENT = "ERE-R",
  ORA_F_CONTRACEPTIVE_PILL = "ORA-F",
  ORA_R_ORAL_CONTRACEPTION_RETURN = "ORA-R",
  MAP_F_MORNING_AFTER_PILL = "MAP-F",
  TRI_F_TRICHOMONIASIS_TREATMENT = "TRI-F",
  SWI_F_SWIMMERS_EAR_TREATMENT = "SWI-F",
  T_CGT_Y_CHLAMYDIA_GONORRHOEA_TRICH_TEST_KIT_MEN = "T-CGT-Y",
  T_CG_Y_CHLAMYDIA_GONORRHOEA_HOME_TEST_KIT_MEN = "T-CG-Y",
  ALT_F_ALTITUDE_SICKNESS = "ALT-F",
  ALT_R_ALTITUDE_SICKNESS_RETURN = "ALT-R",
  STO_F_STOP_SMOKING_TREATMENT = "STO-F",
  STO_R_STOP_SMOKING_RETURN = "STO-R",
  PDE_F_PERIOD_DELAY = "PDE-F",
  BVT_F_BACTERIAL_VAGINOSIS_TREATMENT = "BVT-F",
  HAY_F_HAYFEVER_TREATMENT = "HAY-F",
  PER_F_PERIOD_PAIN_RELIEF = "PER-F",
  ROS_F_ROSACEA_TREATMENT = "ROS-F",
  AST_ASTHMA_INHALERS = "AST",
  JET_F_JET_LAG = "JET-F",
  COL_F_COLD_SORE_TREATMENT = "COL-F",
  SKI_F_SKIN_INFECTION_TREATMENT = "SKI-F",
  MIG_F_MIGRAINE_TREATMENT = "MIG-F",
  GHS_F_GENITAL_HERPES_SUPPRESSION = "GHS-F",
  GHE_F_GENITAL_HERPES_TREATMENT = "GHE-F",
  GEW_F_GENITAL_WARTS_TREATMENT = "GEW-F",
  PSO_F_PSORIASIS_TREATMENT = "PSO-F",
  ANA_F_ANAPHYLAXIS = "ANA-F",
  MEN_F_MENOPAUSE_HRT_TREATMENT = "MEN-F",
  CON_F_CONTACT_DERMATITIS_TREATMENT = "CON-F",
  T_HIV_HIV_HOME_TEST_KIT = "T-HIV",
  EREA_F_ERECTILE_DYSFUNCTION_SUBSCRIBE_AND_SAVE = "EREA-F",
  DAA_R_DEPRESSION_AND_ANXIETY_TREATMENT = "DAA-R",
  SAH_F_SKIN_AGEING_AND_HYPERPIGMENTATION = "SAH-F",
  SAH_R_SKIN_AGEING_AND_HYPERPIGMENTATION_RETURN = "SAH-R",
  SCD_F_SKIN_CONDITION_DIAGNOSIS_TREATMENT = "SCD-F"
}
